import React from "react";
import { UilTimes, UilArrowRight } from "@iconscout/react-unicons";
import Btn from "components/Btn";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function AddMovieHeader({
  currentStep = 1,
  totalSteps = 6,
  title = "Add a single movie",
  onCancel = () => { },
  onSaveDraft = null,
  onContinue = null,
  continueDisabled = false,
  showProgress = false,
  loading
}) {
  const segments = Array.from({ length: totalSteps });
  const [searchParams] = useSearchParams();
  const mediaType = searchParams.get('media_type');
  title = mediaType === 'series' ? 'Add a TV Series' : 'Add a Single Movie';
  const navigate = useNavigate()
  const handleCancel = () => {
    if (typeof onCancel === "function") onCancel();
    navigate(-1);
  };

  return (
    <div className="w-full">
      <header className="bg-white shadow px-6 py-4 flex items-center justify-center">

        <button
          onClick={() => { onCancel?.() || handleCancel?.() }}
          aria-label="Cancel"
          className="text-gray-600 hover:text-gray-800 p-2 absolute left-4"
        >
          <UilTimes className="w-5 h-5" />
        </button>
        <h1 className="text-xl font-extrabold text-gray-800">{title}</h1>

        <div className="flex items-center space-x-3 absolute right-4">
          {typeof onSaveDraft === "function" && <button
            onClick={() => onSaveDraft?.()}
            className="px-3 py-2 border rounded text-gray-700 hover:bg-gray-100 text-sm"
          >
            Save as Draft
          </button>}

          {typeof onContinue === "function" && <Btn
            disabled={continueDisabled}
            click={() => onContinue?.()}
            color={'blue'}
            loading={loading}
            content={<>
              Continue
              <UilArrowRight className="w-4 h-4 ml-2" />
            </>} />}
          {/* <button
            onClick={onContinue}
            disabled={continueDisabled}
            className={`flex items-center px-3 py-2 rounded text-white text-sm ${continueDisabled
              ? "bg-blue-200 cursor-not-allowed"
              : "bg-primary hover:bg-primary-dark"
              }`}
          >
            Continue
            <UilArrowRight className="w-4 h-4 ml-2" />
          </button> */}
        </div>
      </header>

      {showProgress && (
        <div className="h-2 bg-gray-200 flex">
          {segments.map((_, i) => (
            <div
              key={i}
              className={`flex-1 ${i < currentStep ? "bg-primary" : "bg-gray-200"
                }`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
